import React from 'react';
import FormROValue from "../../../library/form/components/FormROValue1";
import FormLabel from "../../../library/form/components/FormLabel";
import FormWrapper from "../../../library/form/components/FormWrapper";
import FormButton from "../../../library/form/components/FormActionButton2";
import FormInput from '../../../library/form/components/FormInput';
import DocChildActivator from "../../cmn/DocChildActivator";
import FormStatus from '../../../library/form/components/FormStatus';

const InvItemMenuRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <div className="phViewAreaItem uiBoxItem phViewContent">
            <div className="phViewRef" >
                <div className="phKeyValueView">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "lineNo" }} className="uiBoxItemLineNo" />

                    <FormWrapper customWrapper="span" formObject={formObject} rowKey={rowKey} 
                        className="uiSpacerH5" action={{ paramName: "docStatus" }} >
                        <FormStatus formObject={formObject}  headerKey={`docStatus_${rowKey}`}/>
                    </FormWrapper>
                </div>
            </div>
            <div className="phViewName">
                <FormROValue className="uiBold" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemCode" }} />
                <FormROValue className="uiSpacerH5" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
            </div>
            <div className="phViewInfo">
                <div className="phKeyValueView">
                    <div className="uiSpacerH5">
                        <FormLabel customWrapper="span" wrapperClass="uiLblInLine uiRed" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemDesc" }} value="Customise" />
                        <FormInput placeholder="" formObject={formObject} rowKey={rowKey} useValF="1" className="uiInput" action={{
                                InputType: "ac",
                                actionId: "refresh", paramName: "itemDesc", 
                                acDepCtrl: { dtid: "#docType", itid:"#itemType" }, acValidate:"0",
                                acMethod: "InvItemDescription", actionParam: { updateDescription:"1", editSource: "itemDesc", viewCaller:"rowViewer" }
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="phViewQty">
                <FormInput formObject={formObject} className="uiInput uiVal40" rowKey={rowKey}
                    action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom1" }} />
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiVal40" 
                    action={{ InputType: "input", actionId: "refresh", refreshMode:"dep", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1", viewCaller:"rowViewer" } }} />
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "uom2" }} />
            </div>
            <div className="phViewCost">
                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "costContainer" }} >
                    <div className="phKeyValueView">
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} value="Price" />
                        </span>
                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} className="uiValue" />
                    </div>
                </FormWrapper>
                <FormWrapper formObject={formObject} rowKey={rowKey} action={{ paramName: "salesContainer" }} >
                    <div className="phKeyValueView">
                        <span className="uiKey">
                            <FormLabel formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} value="Sell Amt" />
                        </span>

                        <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "sellAmt" }} className="uiValue uiHighlightBlue" />
                    </div>
                </FormWrapper>
            </div>
            <div className="phViewAction uiActionBlock">
                <DocChildActivator formObject={formObject} rowKey={rowKey}
                    action={{ actionId: "show", paramName: "childComp", actionParam: {}, containerKey: "popup" }}
                />
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    className="" 
                    action={{ actionId: "edit", paramName: "editBtn", actionParam: { pathKey: "#pathKey" }, containerKey: "popup" }}
                ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                    action={{ actionId: "del", paramName: "delBtn", actionParam: {}, containerKey: "row" }}
                ></FormButton>
            </div>
        </div>
    )
}

export default InvItemMenuRow